export const TableColumnsDistributorCantSee = [
  'priceList',
  'discountValue',
  'discount',
  'contractValue',
  'balanceValue'
];
